export const NoEventsIcon = (): JSX.Element => (
  <svg width="197px" height="197px" fill="none">
    <g clipPath="url(#a)">
      <path
        fill="#F4F4F4"
        d="M98.5 197c54.4 0 98.5-44.1 98.5-98.5S152.9 0 98.5 0 0 44.1 0 98.5 44.1 197 98.5 197Z"
      />
      <rect width="74px" height="29px" x="106px" y="12px" fill="#FF554D" rx="5px" />
      <rect width="40px" height="6px" x="125px" y="24px" fill="#08044F" rx="3px" />
      <rect width="6px" height="6px" x="114px" y="24px" fill="#08044F" rx="3px" />
      <rect width="106px" height="29px" x="11px" y="159px" fill="#1EBDAF" rx="5px" />
      <rect width="67px" height="6px" x="21px" y="170px" fill="#08044F" rx="3px" />
      <rect width="6px" height="6px" x="99px" y="170px" fill="#08044F" rx="3px" />
      <rect width="123px" height="82px" x="37px" y="66px" fill="#0189FF" rx="5px" />
      <rect width="16px" height="6px" x="131px" y="93px" fill="#F4F4F4" rx="3px" />
      <rect width="16px" height="6px" x="131px" y="110px" fill="#F4F4F4" rx="3px" />
      <path
        stroke="#FFBC27"
        strokeLinecap="round"
        strokeWidth="13px"
        d="M68.5 56.5v19M132.5 56.5v19"
      />
      <rect width="16px" height="6px" x="50px" y="93px" fill="#F4F4F4" rx="3px" />
      <rect width="16px" height="6px" x="50px" y="110px" fill="#F4F4F4" rx="3px" />
      <rect width="16px" height="6px" x="50px" y="127px" fill="#F4F4F4" rx="3px" />
      <rect width="16px" height="6px" x="77px" y="93px" fill="#F4F4F4" rx="3px" />
      <rect width="16px" height="6px" x="104px" y="93px" fill="#F4F4F4" rx="3px" />
      <rect width="16px" height="6px" x="104px" y="110px" fill="#F4F4F4" rx="3px" />
      <rect width="16px" height="6px" x="104px" y="127px" fill="#F4F4F4" rx="3px" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h197v197H0z" />
      </clipPath>
    </defs>
  </svg>
)
